import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, Select, MenuItem } from '@mui/material';

// Define styles using makeStyles
const useStyles = makeStyles({
  customDropdown: {
    width: '100%', // Ensures full width for the dropdown
  },
  customMenuItem: {
    display: 'block', // Ensures items stack vertically
    padding: '5px 20px', // Adds padding around each menu item
  },
  selectBox: {
    padding: '4px 8px',
    fontSize: '0.875rem',
    fontWeight: 'bold',
    color: '#1F5493',
    background: 'transparent',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none !important', // remove border
    },
    '& .MuiSelect-select': {
      padding: '6px 0', // keep text aligned
    },
    '& .MuiSvgIcon-root': {
      color: '#1F5493', // dropdown arrow color
    },
  },
  menuPaper: {
    marginTop: 0, // Removes the margin between the dropdown box and the menu items
    paddingTop: 0, // Removes extra padding, if any
    transform: 'translateY(0)', // Ensures the menu is aligned directly below the dropdown
  },
});

const DropdownComponent = ({ selectedDropdownOption, onChange, dropdownOptions }) => {
  const styles = useStyles(); // Access the defined styles

  return (
    <FormControl className={styles.customDropdown}>
      <Select
        labelId="dropdown-label"
        value={selectedDropdownOption || ""}
        onChange={onChange}
        displayEmpty
        className={styles.selectBox}
        MenuProps={{
          PaperProps: {
            className: styles.menuPaper, // Apply custom styles to the dropdown menu
            style: {
              border: "none",
            },
          },
        }}
      >
        <MenuItem value="" disabled className={styles.customMenuItem}>
          Select an option
        </MenuItem>
        {dropdownOptions &&
          dropdownOptions.map((option, index) => (
            <MenuItem key={index} value={option.value} className={styles.customMenuItem}>
              {option.label}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default DropdownComponent;
